import React from "react";
import { Box, Button, IconButton } from "@mui/material";
import StyledDataGrid from "../ui/dataViews/StyledDataGrid";
import Delete from "@mui/icons-material/Delete";

function UserTable({ users, setUsers, width=150, height=400, sx={} }) {
  const uniqueUsers = Array.from(new Map(users.map(user => [user.id, user])).values());
  const columns = [
    { field: "id", 
      headerName: "ID",
      flex: 1, 
    },
    { field: "name", 
      headerName: "User",
      flex: 2, 
    },
    {
      field: "confidence",
      headerName: "Confidence",
      valueGetter: () => "0.8",
      flex: 1,
    },
    {
      field: "currentWorkload",
      headerName: "Current Workload",
      valueGetter: () => "N/A",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Remove",
      renderCell: (params) => (
        <IconButton
          variant="contained"
          color="primary"
          onClick={() => {
            // Add your delete logic here
            console.log("Delete user with ID: ", params.row.id);
            // Update the users state to reflect the changes
            const newUsers = users.filter((user) => user.id !== params.row.id);
            setUsers(newUsers);
          }}
        >
          <Delete />
        </IconButton>
      ),
      flex: 1,
    },
  ];
  return (
    <Box sx={{ height: height, width: "100%", ...sx }}>
      <StyledDataGrid rows={uniqueUsers} columns={columns} sx={{overflowY: "scroll", zIndex: 999}}/>
    </Box>
  );
}

export default UserTable;
